import { ReactComponent as CloseIcon } from '../../../assets/close.svg'
import { numberToCurrency } from "@firestarter-private/firestarter-library/lib/utils/bigNumbers"

interface Props {
  identities: { name: string, price: number, discountedPrice: number }[]
  totalPrice: number
  totalDiscountedPrice: number
  onRemoveIdentity: (name: string) => void
}

export const IdentitiesList = ({ identities, totalPrice, totalDiscountedPrice, onRemoveIdentity }: Props) => {
  return (
    <div className="identities-list">
      {identities.length > 0 && <h4 className="title">Your Identities:</h4>}
      <dl className="info-list">
        {identities.map((identity) => (
          <div key={identity.name}>
            <dt className="name">@{identity.name}</dt>
            <dd className="value d-flex gap-2 align-items-center">
              <span className="text-decoration-line-through">${numberToCurrency(identity.price, 2)}</span>
              <span className="purple-text">${numberToCurrency(identity.discountedPrice, 2)}</span>
              <div>
                <CloseIcon className="close-icon" onClick={() => onRemoveIdentity(identity.name)} />
              </div>
            </dd>
          </div>
        ))}
        <div>
          <dt className="name">
            <big>Total:</big>
          </dt>
          <dd className="value">
            <span className="text-decoration-line-through font-weight-normal">${numberToCurrency(totalPrice, 2)}</span>{' '}
            <big className="purple-text">${numberToCurrency(totalDiscountedPrice, 2)}</big>
          </dd>
        </div>
      </dl>
    </div>
  )
}
